import { useContext } from "react";
import { LogOut } from "lucide-react";
import { SidebarContext } from "../../../context/SidebarContext";
import { logoutService } from "../services";


export default function ContainerSubtitles() {

    const { navigate, user, showText } = useContext(SidebarContext);

    const handleLogout = async () => {
        const response = await logoutService();
        if (response) navigate("/login");
    };

    const initials = user?.nome
        ? user.nome.split(" ").map(s => s[0]).slice(0, 2).join("").toUpperCase()
        : "?";


    return (
        <div className={`p-3 ${showText ? "" : "flex flex-col items-center"}`}>

            {showText && user ? (
                <div className="surface-card p-3 mb-2 animate-fade-in">
                    <div className="flex items-center gap-3">
                        <div className="relative flex-shrink-0">
                            <div className="h-9 w-9 rounded-full bg-gradient-brand grid place-items-center text-white text-xs font-bold tracking-wide">
                                {initials}
                            </div>
                            <span className="absolute -bottom-0.5 -right-0.5 h-2.5 w-2.5 rounded-full bg-positive-500 ring-2 ring-surface-1" />
                        </div>
                        <div className="min-w-0 flex-1">
                            <div className="text-sm font-semibold text-ink-1 truncate">{user.nome}</div>
                            <div className="text-2xs text-ink-4 truncate">{user.nome_empresa}</div>
                        </div>
                    </div>
                </div>
            ) : (
                user && (
                    <div className="relative">
                        <div className="h-9 w-9 rounded-full bg-gradient-brand grid place-items-center text-white text-xs font-bold tracking-wide" title={user.nome}>
                            {initials}
                        </div>
                        <span className="absolute -bottom-0.5 -right-0.5 h-2.5 w-2.5 rounded-full bg-positive-500 ring-2 ring-surface-1" />
                    </div>
                )
            )}

            <button
                onClick={handleLogout}
                title="Sair"
                className={`group flex items-center gap-2 ${showText ? "w-full px-3 py-2.5" : "p-2 mt-3"} rounded-xl text-danger-400 hover:bg-danger-500/10 hover:text-danger-300 ring-1 ring-transparent hover:ring-danger-500/20 transition-all duration-200 ease-out-expo no-tap`}
            >
                <LogOut className="h-4 w-4" strokeWidth={2.2} />
                {showText && <span className="text-sm font-medium">Sair</span>}
            </button>
        </div>
    );
}
